import React from 'react'
import styles from './Header.module.css'

interface SearchIconProps {
  onSearchClick: () => void
  onCloseSearch?: () => void
  isSearchOpen?: boolean
  isMobile?: boolean
}

const SearchIcon: React.FC<SearchIconProps> = ({
  onSearchClick,
  onCloseSearch,
  isSearchOpen = false,
  isMobile = false,
}) => {
  const handleClick = () => {
    if (isMobile && isSearchOpen && onCloseSearch) {
      onCloseSearch()
    } else {
      onSearchClick()
    }
  }

  return (
    <div className={styles.searchContainer}>
      <div
        className={styles.searchInput}
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
        role="button"
        tabIndex={0}
        aria-label={isMobile && isSearchOpen ? 'Закрити пошук' : 'Відкрити пошук'}
        onKeyDown={event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            handleClick()
          }
        }}
      >
        {(!isMobile || !isSearchOpen) && (
          <svg
            className={styles.searchIcon}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.5 17.5L12.5 12.5M14.1667 8.33333C14.1667 11.555 11.555 14.1667 8.33333 14.1667C5.11167 14.1667 2.5 11.555 2.5 8.33333C2.5 5.11167 5.11167 2.5 8.33333 2.5C11.555 2.5 14.1667 5.11167 14.1667 8.33333Z"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        {isMobile && isSearchOpen && (
          <svg
            className={styles.closeIcon}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.66564 18.3353L18.3359 1.66504"
              stroke="#0D0D0D"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1.66564 1.66503L18.3359 18.3353"
              stroke="#0D0D0D"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}

        <div className={styles.searchSeparator}></div>
        <div className={styles.searchField}>Знайди свою каву тут</div>
      </div>
    </div>
  )
}

export default SearchIcon
